import { css } from 'styled-components';
import { PageArrowProps } from '../../../../../components/Pagination/PageArrow/styles';
import { StyledIcon } from '../../../../../components/Pagination/styles';
import colors, { colorWithOpacity } from '../../../../../helpers/colors';
import fonts from '../../../../../helpers/fonts';
import mediaQuery from '../../../../../helpers/mediaQuery';
import spacing from '../../../../../helpers/spacing';
import { themeSpecificColors } from '../../../colors';

const activePageArrow = css`
  && ${StyledIcon} {
    color: ${themeSpecificColors.core04};
  }
  &:hover {
    background-color: ${colors.neutral06};
    text-decoration: none;
    font-weight: normal;
  }
  &:active {
    // TODO - RIR-931 - Extract into common style
    background-color: ${colorWithOpacity(colors.core01, 0.2)};
    color: ${colors.neutral01};
    box-shadow: 0 0 0 2px ${colors.core01};
  }
  &:focus-visible {
    box-shadow: 0 0 0 1px ${colors.core01}, 0 0 0 3px ${colors.neutral08},
      0 0 0 7px ${colorWithOpacity(colors.core01, 0.6)};
  }
`;

export default css<PageArrowProps>`
  && {
    border-radius: 0;
    border: none;
    padding: ${spacing(0.5)} ${spacing(2)};
    ${fonts.paragraphSmall};
    color: ${colors.neutral03};
    opacity: 1;

    ${({ isNextArrow }) => mediaQuery.tabletPortrait`
      span{
        flex-direction: row;
        flex-wrap: ${isNextArrow ? 'wrap-reverse' : 'wrap'};
        margin-left: auto;
        margin-right: auto;
        column-gap: ${spacing(3)};
      }
    `}
    ${mediaQuery.tabletLandscape`
      padding: ${spacing(1)} ${spacing(1.5)};
    `}

    ${StyledIcon} {
      color: ${colors.neutral03};
      ${mediaQuery.tabletPortrait`
        margin-left: auto;
        margin-right: auto;
      `}
    }
    ${({ disabled }) => (disabled ? 'cursor: default;' : activePageArrow)}
  }
`;
